import * as React from "react";
import infoIcon from "../../assets/svg/icon-info.svg";
import { SvgIcon } from "../../components/svg-icon";
import { Text } from '../../components/text';

import * as styles from "./info-message.less";
import { PaymentLabel } from "../../webgiving-generated";

interface IWebGivingInfoMessageProps {
	paymentLabel: PaymentLabel;
}

export const InfoMessage: React.FC<IWebGivingInfoMessageProps> = (props) => {
	const {NounSentenceCase, NounLowerCase} = props.paymentLabel;
	const title = `${NounSentenceCase || 'Payment'} processing ...`;
	const content = `Your ${NounLowerCase || 'payment'} is still processing, please give it a few more seconds`;
	
	return(
	<div className={styles.container}>
		<div className={styles.header}>
			<SvgIcon className={styles.icon} svg={infoIcon} />
			<p className={styles.headerText}>
				<strong><Text>{title}</Text></strong>
			</p>
		</div>
		<p className={styles.description}><Text>{content}</Text></p>
	</div>
)};
